import React from 'react';
import Button from '../../../components/ui/Button';

const AddDealButton = ({ onClick, stage }) => {
  return (
    <div className="px-3 md:px-4 pb-3 md:pb-4">
      <Button
        variant="outline"
        fullWidth
        onClick={() => onClick(stage)}
        iconName="Plus"
        iconPosition="left"
        className="border-dashed"
      >
        Add Deal
      </Button>
    </div>
  );
};

export default AddDealButton;